import React from 'react';
import {Container, Row, Col} from 'react-bootstrap'
import Thumbnail from "../../components/thumbnail";
import Content from "../../components/content";
import aboutData from '../../data/AboutMe'

import AccountSettings from "../../components/account";


const AccountSettingsContainer = ({type}) => {
    const lang = "en";

    return (
        <Container>
            <AccountSettings/>
        </Container>
    );
};

export default AccountSettingsContainer;